import clarity from '@microsoft/clarity';
import { useEffect } from 'react';

import { useApplicationContext } from '../../../modules/context/ApplicationContext/ApplicationContext';
import { useAuthContext } from '../../../modules/login/AuthContext';
import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';

type ClarityProps = {
  path: string;
  name?: string;
};

const Clarity = ({ name, path }: ClarityProps) => {
  const { team } = useApplicationContext();
  const { user } = useAuthContext();
  const appEnvironment = useAppEnvironmentStore((state) => state.appEnvironment);

  useEffect(() => {
    if (window.clarity) {
      clarity.identify(team?.userId || '', user?.session, path, name);
    }
  }, [team?.userId, user?.session, path, name]);

  useEffect(() => {
    if (window.clarity && appEnvironment) {
      clarity.setTag('appEnvironment', appEnvironment);
    }
  }, [appEnvironment]);

  return null;
};

export default Clarity;
